const TelegramIcon = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6609 27.735C24.0473 28.0086 24.5453 28.077 24.9893 27.909C25.4333 27.7398 25.7597 27.3606 25.8581 26.901C26.9009 22.0002 29.4305 9.59578 30.3797 5.13778C30.4517 4.80178 30.3317 4.45258 30.0677 4.22818C29.8037 4.00378 29.4377 3.93898 29.1113 4.06018C24.0797 5.92258 8.5841 11.7366 2.25049 14.0802C1.84849 14.229 1.58689 14.6154 1.60009 15.039C1.61449 15.4638 1.90009 15.8322 2.31169 15.9558C5.15209 16.8054 8.8805 17.9874 8.8805 17.9874C8.8805 17.9874 10.6229 23.2494 11.5313 25.9254C11.6453 26.2614 11.9081 26.5254 12.2549 26.6166C12.6005 26.7066 12.9701 26.6118 13.2281 26.3682C14.6873 24.9906 16.9433 22.8606 16.9433 22.8606C16.9433 22.8606 21.2297 26.0034 23.6609 27.735ZM10.4489 17.3226L12.4637 23.9682L12.9113 19.7598C12.9113 19.7598 20.6957 12.7386 25.1333 8.73658C25.2629 8.61898 25.2809 8.42218 25.1729 8.28418C25.0661 8.14618 24.8693 8.11378 24.7217 8.20738C19.5785 11.4918 10.4489 17.3226 10.4489 17.3226Z"
      />
    </svg>
  )
}

export default TelegramIcon
